import React, { createContext, useState, useEffect, useCallback } from "react";
import { getApi, postApi } from "../services/api";

// Create the AuthContext
export const AuthContext = createContext();

// Create a provider component
export const AuthProvider = ({ children }) => {
	// State to hold user authentication status
	const [user, setUser] = useState(null);

	// State to hold access token
	const [accessToken, setAccessToken] = useState(() => {
		// Initialize from localStorage if available
		return localStorage.getItem("accessToken") || null;
	});
	const [loading, setLoading] = useState(true);
	const [tokenChangePending, setPending] = useState(false);
	let checkLogin;
	const login = useCallback(
		(response) => {
			if (response.accessToken) setAccessToken(response.accessToken);
			if (response.user) setUser(response.user);
			if (response.accessToken && !response.user) {
				checkLogin();
			}
		},
		[checkLogin]
	);

	const logout = useCallback(async () => {
		await postApi("/auth/logout");
		setAccessToken(null);
		setUser(null);
	}, []);

	checkLogin = useCallback(async () => {
		try {
			setLoading(true);

			if (!accessToken) {
				throw new Error("Invalid access token");
			}
			const data = await getApi("/users/me", { accessToken });
			login(data);
			setLoading(false);
		} catch (error) {
			console.error("Error fetching user's data:", error.message);
			console.error("Access Token:", accessToken);
			setPending(true);
			setUser(null);
		}
	}, [accessToken, login]);

	useEffect(() => {
		if (accessToken) {
			localStorage.setItem("accessToken", accessToken);
		} else {
			localStorage.removeItem("accessToken");
		}
	}, [accessToken]);

	useEffect(() => {
		if (!tokenChangePending) checkLogin();
	}, [tokenChangePending, checkLogin, accessToken]);

	return (
		<AuthContext.Provider
			value={{ user, login, logout, loading, setPending, accessToken }}
		>
			{children}
		</AuthContext.Provider>
	);
};
